<template>
  <a-modal
      :title="title"
      centered
      :maskClosable="false"
      :visible="popConfig.show"
      :closable="true"
      @cancel="closeModal"
      :footer="null"
      :width="1000"
  >
    <slot v-if="popConfig.show"></slot>
  </a-modal>

  <!--  <popModal-->
  <!--      title="标题"-->
  <!--      :pop-config="popConfig.test"-->
  <!--  >-->
  <!--  </popModal>-->
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    popConfig: {
      type: Object,
      default() {
        return {
          show: false,
          id: -1,
          row: {}
        }
      }
    },
    closeMethod: {
      type: Function,
    }
  },
  methods: {
    closeModal() {
      console.log(this.$parent)
      this.$parent.closePopAndRefresh();
    }
  },
}
</script>

<style lang="less">
</style>